export default [
    {
        path: '/abnormal/abEntrance', // 入口
        component: resolve => require(['@/pages/luggage/abnormal/abEntrance'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/abnormal/abSearchInfo', // 填写信息查询航班
        component: resolve => require(['@/pages/luggage/abnormal/abSearchInfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/abnormal/abLostForm', // 填写遗失表单
        component: resolve => require(['@/pages/luggage/abnormal/abLostForm'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/abnormal/abWornForm', // 填写遗破损表单
        component: resolve => require(['@/pages/luggage/abnormal/abWornForm'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/abnormal/abMyDeclare', // 我的申报列表 
        component: resolve => require(['@/pages/luggage/abnormal/abMyDeclare'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/abnormal/abMyDeclareDetail', // 我的申报详情
        component: resolve => require(['@/pages/luggage/abnormal/abMyDeclareDetail'], resolve),
        meta: { title: "长龙航空" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/luggage.js